<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="添加故障"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="420px"
  >
    <div class="dialog__container edit-department">
      <el-form
        inline
        ref="form"
        class="search-form"
        label-position="right"
        :model="form"
        :rules="rules"
        label-width="70px"
      >
        <el-form-item label="类型名称：" prop="name">
          <el-input
            size="mini"
            v-model.trim="form.name"
            placeholder="请输入部门名称："
            clearable
          ></el-input>
        </el-form-item>
         <el-form-item label="模板名称：" prop="templateId">
          <el-select
            size="mini"
            v-model="templateObj"
            filterable
            placeholder="请选择模板名称"
            clearable
            reserve-keyword
            :remote="true"
            :remote-method="searchPointTemplate"
            @visible-change="searchPointTemplate('')"
            @change="chooseTemplate"
            value-key="id"
          >
            <el-option
              v-for="item in templateList"
              :key="item.id"
              :label="item.templateName"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="故障原因：" prop="faultReasonId">
          <el-select
            size="mini"
            v-model="faultReasonObj"
            filterable
            placeholder="请选择故障原因"
            clearable
            reserve-keyword
            :remote="true"
            :remote-method="searchReasonList"
            @visible-change="searchReasonList('')"
            @change="chooseFault"
            value-key="id"
          >
            <el-option
              v-for="item in reasonList"
              :key="item.id"
              :label="item.faultReason"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注信息：">
          <el-input
            size="mini"
            v-model.trim="form.remark"
            placeholder="请输入备注信息"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="plr28"
        size="mini"
        type="info"
        plain
        @click="handleCancel"
        >取消</el-button
      >
      <el-button
        class="plr28"
        type="primary"
        size="mini"
        :loading="loadBtn"
        @click="handleConfirm"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { getFaultReasonList, savePoint, getPointTemplateList } from "@/api/FaultTypesItems";
export default {
  data() {
    return {
      form: {
        name: "",
        faultReasonId: "",
        remark: "",
        templateId: ''
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入部门名称",
            trigger: "blur",
          },
        ],
        templateId: [
          {
            required: true,
            message: "请选择模板名称",
            trigger: "change",
          },
        ],
        faultReasonId: [
          {
            required: true,
            message: "请选择故障原因",
            trigger: "change",
          },
        ],
      },
      loadBtn: false,
      defaultReasonList: [],
      defaultProps: {
        label: "name",
        children: "liftList",
      },
      selectLifts: [],
      liftListLengths: 0,
      reasonList: [],
      faultReasonObj: null,
      templateObj: null,
      templateList: []
    };
  },
  props:['editData'],
  methods: {
    async searchReasonList(keyword) {
      const res = await getFaultReasonList({
        faultReason: keyword,
        size: 100,
      });
      if (res.code === 200) {
        this.reasonList = res.data;
      }
    },
    async searchPointTemplate(keyword) {
      const res = await getPointTemplateList({
        templateName: keyword,
        size: 100,
      });
      if (res.code === 200) {
        this.templateList = res.data;
      }
    },
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async handleConfirm() {
      if (this.loadBtn) return;
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.loadBtn = true;
          if (!this.editData) {
            this.form.parentId = 0
          } else {
            this.form.parentId = this.editData.id
          }
          const res = await savePoint(this.form);
          if (res.code === 200) {
            this.$message.success("添加成功");
            this.$emit("confirm");
          }
          this.loadBtn = false;
        }
      });
    },
    chooseFault(row) {
      if (row) {
        this.form.faultReasonId = row.id
        this.form.faultReasonName = row.faultReason
      } else {
        this.form.faultReasonId = ''
        this.form.faultReasonName = ''
      }
      
    },
    chooseTemplate(row) {
      if (row) {
        this.form.templateId = row.id
        this.form.templateName = row.templateName
      } else {
        this.form.templateId = ''
        this.form.templateName = ''
      }
    }
  },
};
</script>
<style lang="scss">
.edit-department {
  .el-tree-node__children {
    .el-checkbox {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/FaultTypesItems/components/AddFault.vue